import React from 'react';
import DesignBrand from './design-brand';
import DesignIntro from './design-intro';
import DesignQuote from './design-quote';
import DesignSketching from './design-sketching';
import DesignWireframing from './design-wireframing';
import DesignBrandBook from './design-brand-book';
import DesignVisual from './design-visual';
import DesignPrototype from './design-prototype';
import DesignIllustrations from './design-illustrations';
import DesignContact from './design-contact';
import { ContainerFluid } from '../../components';

export default function DesignPage() {
  return (
    <ContainerFluid>
      <DesignIntro />
      <DesignQuote />
      <DesignSketching />
      <DesignWireframing />
      <DesignBrand />
      <DesignBrandBook />
      <DesignVisual />
      <DesignPrototype />
      <DesignIllustrations />
      <DesignContact />
    </ContainerFluid>
  );
}
